export enum FirebaseEventEnum {
  PAGE_VIEW = "page_view",
  FEATURE_ACCESS = "feature_access",
}
